/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'underscore';
import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DefaultButton, PrimaryButton, Link, Text } from '@fluentui/react';

import { getBaseModalFooterStyles, baseModalFooterStyles } from './styles/step-base-modal-footer-styles';

export function StepModalFooter(props) {
  const {
    onPreviousClick,
    onNextClick,
    onSkippingLinkClick,
    skippingLinkTitle,
    nextButtonText,
    previousButtonText,
    stepProgressContent,
    isPreviousDisabled,
  } = props;
  const classes = useDefaultStyles(getBaseModalFooterStyles);
  const i18n = useContext(I18nContext);

  return (
    <div className={classNames('step-modal-footer', classes.stepModalFooterContainer)}>
      {
        _.isFunction(onSkippingLinkClick) && (
          <div className={classNames('skip-link-container')}>
            <Link
              className={classNames(['link-button', 'step-skip', classes.skipLink])}
              onClick={onSkippingLinkClick}
            >
              {skippingLinkTitle || i18n.getString(_TL_('Skip campaign creation')) }
            </Link>
          </div>
        )
      }

      {
        stepProgressContent &&
        <div className={classNames('step-progress-container', classes.stepProgressContainer)}>
          <Text
            variant="medium"
            block
            styles={baseModalFooterStyles.stepProgress}
            className="step-progress"
          >
            {stepProgressContent}
          </Text>
        </div>
      }

      <div className={classes.actionsContainer}>
        {
          _.isFunction(onPreviousClick) &&
          <DefaultButton
            className={classNames('step-previous', classes.defaultButton)}
            onClick={onPreviousClick}
            disabled={isPreviousDisabled}
          >
            {previousButtonText || i18n.getString(_TL_('Previous'))}
          </DefaultButton>
        }
        {
        _.isFunction(onNextClick) &&
        <PrimaryButton
          className={classNames('step-next', classes.primaryButton)}
          onClick={onNextClick}
        >
          {nextButtonText || i18n.getString(_TL_('Next'))}
        </PrimaryButton>
      }
      </div>

    </div>
  );
}

StepModalFooter.propTypes = {
  nextButtonText: PropTypes.string,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onSkippingLinkClick: PropTypes.func,
  skippingLinkTitle: PropTypes.string,
  previousButtonText: PropTypes.string,
  stepProgressContent: PropTypes.string,
  isPreviousDisabled: PropTypes.bool,
};

StepModalFooter.defaultProps = {
  nextButtonText: null,
  onPreviousClick: null,
  onNextClick: null,
  onSkippingLinkClick: null,
  skippingLinkTitle: null,
  previousButtonText: null,
  stepProgressContent: null,
  isPreviousDisabled: false,
};
